import { render, staticRenderFns } from "./editTask.vue?vue&type=template&id=1170fec8&scoped=true&"
import script from "./editTask.vue?vue&type=script&lang=js&"
export * from "./editTask.vue?vue&type=script&lang=js&"
import style0 from "./editTask.vue?vue&type=style&index=0&id=1170fec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1170fec8",
  null
  
)

export default component.exports